export const SEARCH_ENGINES = {
  baidu: { label: '百度', baseUrl: 'https://www.baidu.com/s?wd=' },
  bing: { label: '必应', baseUrl: 'https://www.bing.com/search?q=' },
  google: { label: 'Google', baseUrl: 'https://www.google.com/search?q=' },
  yandex: { label: 'Yandex', baseUrl: 'https://yandex.com/search/?text=' },
} as const;

export type SearchEngine = keyof typeof SEARCH_ENGINES;

export function isSearchEngine(value: string | null): value is SearchEngine {
  return Boolean(value && value in SEARCH_ENGINES);
}

export function buildSearchUrl(engine: SearchEngine, query: string) {
  const cleaned = query.trim();
  return cleaned ? `${SEARCH_ENGINES[engine].baseUrl}${encodeURIComponent(cleaned)}` : null;
}
